module.exports = __webpack_public_path__ + "static/media/fun-coding-class-online.07cb3130.jpg";